import { store } from 'redux/store';
import ChangeNcStatus from 'modules/_shared/components/Modals/ChangeNcStatus';
import { setModal } from 'modules/_shared/redux/modalActions';

export default function updateNcStatus({ data: draft }) {
  store.dispatch(setModal(<ChangeNcStatus draft={draft} />));
}
